import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { Row, Col } from 'react-flexbox-grid'
import { Button, Card, Form, Icon, Image, Input, Message, Divider } from 'semantic-ui-react'
import Logo from '../images/logo-admin.png'
import { Text, Translate, LanguageContext } from '../helpers/language';
import { passUpdate } from '../actions/actionCreators'
import { NotificationManager } from 'react-notifications';

class PasswordUpdate extends React.Component {

  state = {
    oldPassword: '',
    newPassword: '',
    confimNewPassword: '',
    message: '',
    errors: {},
  };

  validatePass = () => {
    const fieldsErrors = {};
    if (this.state.oldPassword === '') fieldsErrors.oldPassword = Translate(this.context,'old_password_is_required');
    if (this.state.newPassword === '') fieldsErrors.newPassword = Translate(this.context,'old_password_is_required');
    if (this.state.confimNewPassword === '') fieldsErrors.confimNewPassword = Translate(this.context,'repeat_password_is_required');
    if (this.state.newPassword !== '' && this.state.confimNewPassword !== '' && this.state.newPassword !== this.state.confimNewPassword)
    fieldsErrors.confimNewPassword = Translate(this.context,'passwords_dont_match')

    return Object.keys(fieldsErrors).length ? fieldsErrors : false;
  };

  updatePassword = async (event) => {
    event.preventDefault()
    const validateErrors = this.validatePass();
    if (validateErrors) {
      this.setState({errors: validateErrors});
    } else {
      try{
        this.props.dispatch(passUpdate( {email: this.props.auth.user.email, oldPass: this.state.oldPassword, newPass: this.state.newPassword} )).then( () => {
          const message = this.props.passwordUpdate.message ? Translate(this.context, this.props.passwordUpdate.message) : ''
          const success = this.props.passwordUpdate.success
          if (message && success) {
            window.dataLayer.push({
              event: 'user_event',
              eventProps: {
                category: 'user_action',
                action: 'password_update',
                label: 'User Password Updated',
                value: 'true'
            }
            });
            NotificationManager.success(message);
          } else if (message) {
            window.dataLayer.push({
              event: 'user_event',
              eventProps: {
                category: 'user_action',
                action: 'password_update_failed',
                label: 'User Password Update Failed',
                value: 'false'
            }
            });
            NotificationManager.error(message);
          }
        })
      }
      catch(error){
        this.setState({ error: Translate(this.context,'generic_fail_message')})
      }
    }
  }
  
  handleChange = (event) => {
    this.setState({errors: {...this.state.errors, [event.target.name]: ''}})
    this.setState({[event.target.name]: event.target.value});
  }

  render() {
    return (
      <div className="lisia-dialog lisia-change-password-dialog">
          <Row center="xs">
            <Col className='password-update-wrapper' xs={11} sm={9} md={7} lg={3}>
              <Card fluid={true} raised={true} centered={true}>
                <Card.Content>
                  <div className="passwordUpdateForm">
                    <Image size='small' src={ Logo } className='m-b-10 lisia-logo'/>
                    <Form onSubmit={this.updatePassword.bind(this)}>
                      <h3 className='text-center'><Text tid='update_password' /></h3>                       
                      <Divider />
                      <Form.Field>
                          <label style={{float: 'left'}} ><Text tid='insert_old_password' /></label>
                          <Form.Input
                              error={this.state.errors.oldPassword !== '' ? this.state.errors.oldPassword : false}
                              value={this.state.oldPassword}
                              onChange={this.handleChange}
                              name="oldPassword"
                              placeholder={Translate(this.context, 'insert_old_password')}
                              type="password"
                          />
                      </Form.Field>
                      <Form.Field>
                          <label style={{float: 'left'}}><Text tid='insert_new_password' /></label>
                          <Form.Input
                              error={this.state.errors.newPassword !== '' ? this.state.errors.newPassword : false}
                              value={this.state.newPassword}
                              onChange={this.handleChange}
                              name="newPassword"
                              type="password"
                              placeholder={Translate(this.context, 'insert_new_password')}
                          />
                      </Form.Field>
                      <Form.Field>
                          <Form.Input
                              error={this.state.errors.confimNewPassword !== '' ? this.state.errors.confimNewPassword : false}
                              value={this.state.confimNewPassword}
                              onChange={this.handleChange}
                              name="confimNewPassword"
                              type="password"
                              placeholder={Translate(this.context, 'confirm_new_password')}
                          />
                      </Form.Field>                      
                      <Button type="submit" style={{width: '100%'}} className='lisia-blue'>
                        <Icon name='checkmark' /> <Text tid="change_password_button" />
                      </Button>
                      <Divider />
                      <div className='footer'>
                        <Link to="/profile">
                          <Text tid="back_to_profile" />
                        </Link>
                        <Link to="/restore">
                            <Text tid="restore_password" />
                        </Link>
                      </div>
                    </Form>
                  </div>
                </Card.Content>
              </Card>
            </Col>
          </Row>          
      </div>
    )
  }
}

PasswordUpdate.contextType = LanguageContext;

const mapStateToProps = (state) => ({
  auth: state.auth,
  passwordUpdate: state.passwordUpdate
})

export default connect(mapStateToProps)(PasswordUpdate)
